import { Property } from './Property';

type PropertyDetailDTO = {
  id: string,
  address: string,
  beds: number,
  baths: number,
  sqft: number,
  listPrice: number,
  listPricePerSqft: number,
  equity: number,
  avm: number,
  avmPerSqft: number,
  daysOnMarket: number,
  imgUrl: string,
  status: string,
  daysSinceSold: number,
  annualTaxes: number | null,
  taxAssessedValue: number | null,
  yearBuilt: number | null,
  subdivision: string | null,
  garage: string | null,
};

export class PropertyDetail extends Property {
  constructor(
    id: string,
    address: string,
    beds: number,
    baths: number,
    sqft: number,
    listPrice: number,
    listPricePerSqft: number,
    equity: number,
    daysOnMarket: number,
    imgUrl: string,
    status: string,
    daysSinceSold: number,
    public readonly avm: number,
    public readonly avmPerSqft: number,
    public readonly annualTaxes: number | null,
    public readonly taxAssessedValue: number | null,
    public readonly yearBuilt: number | null,
    public readonly subdivision: string | null,
    public readonly garage: string | null,
  ) {
    super(id, address, beds, baths, sqft, listPrice, listPricePerSqft, equity, daysOnMarket, imgUrl, status, daysSinceSold);
  }

  static fromDetailDTO(dto: PropertyDetailDTO): PropertyDetail {
    return new PropertyDetail(
      dto.id,
      dto.address,
      dto.beds,
      dto.baths,
      dto.sqft,
      dto.listPrice,
      dto.listPricePerSqft,
      dto.equity,
      dto.daysOnMarket,
      dto.imgUrl,
      dto.status,
      dto.daysSinceSold,
      dto.avm,
      dto.avmPerSqft,
      dto.annualTaxes,
      dto.taxAssessedValue,
      dto.yearBuilt,
      dto.subdivision,
      dto.garage
    );
  }
}
